export class MapKeyConstant {
  public static get FC21KEYS(): any {
    return {
      cs: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '+',
        '2': 'ě',
        '3': 'š',
        '4': 'č',
        '5': 'ř',
        '6': 'ž',
        '7': 'ý',
        '8': 'á',
        '9': 'í',
        '0': 'é',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'z',
        r: 'v',
        c: 'o',
        y: 'a',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'mezerník',
        e: 'k',
        g: 'g',
        '-': '-',
      },
      da: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'v',
        '=': '+',
        s: 's',
        d: 'f',
        r: 'g',
        c: 'r',
        y: 'j',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'mellemrum',
        e: 'k',
        g: 'i',
        '-': '-',
      },
      de: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'v',
        i: 'a',
        '=': '+',
        s: 'h',
        d: 'd',
        r: 'w',
        c: 'l',
        y: 'j',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'leertaste',
        e: 'k',
        g: 'e',
        '-': '-',
      },
      en: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'space',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      es: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '¡',
        s: 'p',
        d: 'd',
        r: 'r',
        c: 'b',
        y: 's',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'espaciadora',
        e: 'm',
        g: 'a',
        '-': '-',
      },
      fi: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '+',
        s: 'j',
        d: 't',
        r: 'u',
        c: 'c',
        y: 'y',
        n: 'e',
        x: 'x',
        esc: 'esc',
        space: 'välilyönti',
        e: 'k',
        g: 'a',
        '-': '-',
      },
      fr: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '&',
        '2': 'é',
        '3': "'",
        '4': '(',
        '5': '§',
        '6': 'è',
        '7': '!',
        '8': 'ç',
        '9': 'à',
        '0': ')',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'd',
        r: 'm',
        c: 'e',
        y: 'o',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'd’espace',
        e: 'c',
        g: 'p',
        '-': '-',
      },
      he: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'ס',
        i: 'מ',
        '=': '=',
        s: 'ח',
        d: 'כ',
        r: 'ר',
        c: 'נ',
        y: 'ק',
        n: 'ל',
        x: 'א',
        esc: 'esc',
        space: 'מקש הרוחים',
        e: 'צ',
        g: 'ג',
        '-': '–',
      },
      hy: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'հ',
        i: 'ի',
        '=': '=',
        s: 'ս',
        d: 'տ',
        r: 'ր',
        c: 'գ',
        y: 'ե',
        n: 'ն',
        x: 'ց',
        esc: 'esc',
        space: 'տարածություն',
        e: 'է',
        g: 'կ',
        '-': '-',
      },
      id: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'r',
        i: 'i',
        '=': '=',
        s: 'd',
        d: 'g',
        r: 'u',
        c: 'c',
        y: 'y',
        n: 't',
        x: 'x',
        esc: 'esc',
        space: 'spasi',
        e: 'k',
        g: 'p',
        '-': '-',
      },
      it: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'c',
        i: 't',
        '=': 'ì',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'p',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'spaziatrice',
        e: 'm',
        g: 'i',
        '-': '-',
      },
      ja: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': 'ぬ',
        '2': 'ふ',
        '3': 'あ',
        '4': 'う',
        '5': 'え',
        '6': 'お',
        '7': 'や',
        '8': 'ゆ',
        '9': 'よ',
        '0': 'わ',
        h: 'く',
        i: 'に',
        '=': 'へ',
        s: 'と',
        d: 'し',
        r: 'す',
        c: 'そ',
        y: 'ん',
        n: 'み',
        x: 'さ',
        esc: 'esc',
        space: 'スペースキー',
        e: 'い',
        g: 'き',
        '-': 'ほ',
      },
      ko: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'ㅐ',
        i: 'ㅌ',
        '=': '=',
        s: 'ㄴ',
        d: 'ㄷ',
        r: 'ㄱ',
        c: 'ㅊ',
        y: 'ㅛ',
        n: 'ㅜ',
        x: 'ㅁ',
        esc: 'esc',
        space: '스페이스 바',
        e: 'ㅏ',
        g: 'ㅅ',
        '-': '-',
      },
      nb: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'o',
        '=': '+',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'f',
        y: 'j',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'mellomrom',
        e: 'v',
        g: 'i',
        '-': '-',
      },
      nl: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'g',
        i: 'i',
        '=': '=',
        s: 'b',
        d: 'v',
        r: 'z',
        c: 'w',
        y: 'j',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'spatie',
        e: 'e',
        g: 's',
        '-': '-',
      },
      pl: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': 'ż',
        s: 's',
        d: 'p',
        r: 'r',
        c: 'w',
        y: 't',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'spacja',
        e: 'e',
        g: 'u',
        '-': '-',
      },
      'pt-BR': {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 't',
        '=': '+',
        s: 'm',
        d: 'd',
        r: 'r',
        c: 'a',
        y: 's',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'spaço',
        e: 'e',
        g: 'c',
        '-': '-',
      },
      ru: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'и',
        i: 'о',
        '=': '=',
        s: 'ы',
        d: 'у',
        r: 'к',
        c: 'ч',
        y: 'д',
        n: 'т',
        x: 'с',
        esc: 'esc',
        space: 'пробел',
        e: 'п',
        g: 'н',
        '-': '-',
      },
      sv: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '+',
        s: 's',
        d: 'd',
        r: 'b',
        c: 'r',
        y: 'j',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'mellanslag',
        e: 'v',
        g: 'g',
        '-': '-',
      },
      th: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': 'ๅ',
        '2': '/',
        '3': '_',
        '4': 'ภ',
        '5': 'ถ',
        '6': 'ุ',
        '7': 'ึ',
        '8': 'ค',
        '9': 'ต',
        '0': 'จ',
        h: 'ร',
        i: 'ท',
        '=': 'ช',
        s: 'อ',
        d: 'ส',
        r: 'พ',
        c: 'ล',
        y: 'ใ',
        n: 'ไ',
        x: 'ป',
        esc: 'esc',
        space: 'สเปซบาร์',
        e: 'แ',
        g: 'ก',
        '-': '-',
      },
      tr: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'g',
        i: 'o',
        '=': '=',
        s: 'p',
        d: 'i',
        r: 't',
        c: 'b',
        y: 'e',
        n: 'h',
        x: 'x',
        esc: 'esc',
        space: 'Boşluk',
        e: 'k',
        g: 'a',
        '-': '-',
      },
      vi: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': 'ă',
        '2': 'â',
        '3': 'ê',
        '4': 'ô',
        '5': '`',
        '6': ' ̉',
        '7': '~',
        '8': '´',
        '9': ' ̣',
        '0': 'đ',
        h: 'l',
        i: 'h',
        '=': '₫',
        s: 'd',
        d: 'n',
        r: 'r',
        c: 'm',
        y: 'c',
        n: 'k',
        x: 'x',
        esc: 'esc',
        space: 'dấu cách',
        e: 'b',
        g: 't',
        '-': '-',
      },
      'zh-Hans': {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: '竹',
        i: '戈',
        '=': '=',
        s: '尸',
        d: '木',
        r: '口',
        c: '金',
        y: '卜',
        n: '弓',
        x: '難',
        esc: 'esc',
        space: '空格键',
        e: '水',
        g: '土',
        '-': '-',
      },
      'zh-Hant': {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: '竹',
        i: '戈',
        '=': '=',
        s: '尸',
        d: '木',
        r: '口',
        c: '金',
        y: '卜',
        n: '弓',
        x: '難',
        esc: 'esc ',
        space: '空白鍵',
        e: '水',
        g: '土',
        '-': '-',
      },
      ar: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠',
        h: 'ا',
        i: 'ه',
        '=': '=',
        s: 'س',
        d: 'ي',
        r: 'ق',
        c: 'ص',
        y: 'غ',
        n: 'ن',
        x: 'خ',
        esc: 'esc',
        space: 'شريط المسافة',
        e: ' ث',
        g: ' ل',
        '-': '-',
      },
      bg: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'г',
        i: 'с',
        '=': '.',
        s: 'я',
        d: 'а',
        r: 'и',
        c: 'ъ',
        y: 'щ',
        n: 'х',
        x: 'й',
        esc: 'esc',
        space: 'интервал',
        e: 'е',
        g: 'ж',
        '-': '-',
      },
      ee: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '+',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'space',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      ge: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'პ',
        i: 'ს',
        '=': '=',
        s: 'ზ',
        d: 'ვ',
        r: 'კ',
        c: 'ყ',
        y: 'ნ',
        n: 'ი',
        x: 'ჩ',
        esc: 'esc',
        space: 'ფართი',
        e: 'უ',
        g: 'ა',
        '-': '-',
      },
      gr: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'η',
        i: 'ι',
        '=': '=',
        s: 'σ',
        d: 'δ',
        r: 'ρ',
        c: 'ψ',
        y: 'υ',
        n: 'ν',
        x: 'χ',
        esc: 'esc',
        space: 'χώρος',
        e: 'ε',
        g: 'γ',
        '-': '-',
      },
      'hi-IN': {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०',
        h: 'प',
        i: 'ग',
        '=': '=',
        s: 'म',
        d: 'क',
        r: 'द',
        c: 'र',
        y: 'ब',
        n: 'ल',
        x: 'स',
        esc: 'esc',
        space: 'स्पेस बार',
        e: 'त',
        g: 'ज',
        '-': '-',
      },
      hu: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': 'ö',
        h: 'h',
        i: 'i',
        '=': 'ó',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'szóköz',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      lt: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': 'ą',
        '2': 'č',
        '3': 'ę',
        '4': 'ė',
        '5': 'į',
        '6': 'š',
        '7': 'ų',
        '8': 'ū',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': 'ž',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'tarpo',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      kh: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០',
        h: 'ហ',
        i: 'ក',
        '=': 'ឥ',
        s: 'ស',
        d: 'ដ',
        r: 'រ',
        c: 'ច',
        y: 'យ',
        n: 'ន',
        x: 'ខ',
        esc: 'esc',
        space: 'របារដកឃ្លា',
        e: 'ង',
        g: 'ប',
        '-': 'ឲ',
      },
      lv: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'taustiņš',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      mt: {
        uikeyinputleftarrow: 'arrowleft',
        uikeyinputrightarrow: 'arrowright',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'spazjali',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      my: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'ruang',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      ph: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'patlang',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      ro: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '=',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'spațiul',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      si: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '+',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'vesoljski',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      sk: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '+',
        '2': 'ľ',
        '3': 'š',
        '4': 'č',
        '5': 'ť',
        '6': 'ž',
        '7': 'ý',
        '8': 'á',
        '9': 'í',
        '0': '0',
        h: 'h',
        i: 'i',
        '=': '`',
        s: 's',
        d: 'd',
        r: 'r',
        c: 'c',
        y: 'y',
        n: 'n',
        x: 'x',
        esc: 'esc',
        space: 'medzerník',
        e: 'e',
        g: 'g',
        '-': '-',
      },
      'sr-RS': {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'х',
        i: 'и',
        '=': '+',
        s: 'с',
        d: 'д',
        r: 'р',
        c: 'ц',
        y: 'з',
        n: 'н',
        x: 'џ',
        esc: 'esc',
        space: 'razmak',
        e: 'е',
        g: 'г',
        '-': '-',
      },
      'ta-IN': {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'க',
        i: 'ன',
        '=': '=',
        s: 'இ',
        d: 'உ',
        r: 'ஐ',
        c: 'ஒ',
        y: 'ள',
        n: 'ல',
        x: 'ஓ',
        esc: 'esc',
        space: 'இடைவெளி',
        e: 'ம',
        g: 'எ',
        '-': '-',
      },
      ua: {
        arrowleft1: 'uikeyinputleftarrow',
        arrowright1: 'uikeyinputrightarrow',
        arrowleft: 'arrowleft',
        arrowright: 'arrowright',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0',
        h: 'р',
        i: 'ш',
        '=': '=',
        s: 'і',
        d: 'в',
        r: 'к',
        c: 'с',
        y: 'н',
        n: 'т',
        x: 'ч',
        esc: 'esc',
        space: 'Пробіл',
        e: 'у',
        g: 'п',
        '-': '-',
      },
    };
  }

  getInputFromKeyInput(key, lang, game) {
    return this['key_' + game][lang.toLowerCase()][key];
  }
}
